import { render } from "./DeleteCasinoModal.vue?vue&type=template&id=0e72095a&scoped=true"
import script from "./DeleteCasinoModal.vue?vue&type=script&lang=js"
export * from "./DeleteCasinoModal.vue?vue&type=script&lang=js"

import "./DeleteCasinoModal.vue?vue&type=style&index=0&id=0e72095a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e72095a"]])

export default __exports__